(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-gallery-track]');
    const slides = [...root.querySelectorAll('[data-gallery-image]')];
    const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const count = root.querySelector('[data-gallery-count]');
    const dialog = root.querySelector('[data-zoom]');
    const enlarged = root.querySelector('[data-zoom-content]');
    const enlarge = root.querySelector('[data-enlarge]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let galleryWidth = track.clientWidth;
    let returnFocus = null;
    const refresh = () => {
      if (!track.clientWidth || track.clientWidth !== galleryWidth) return;
      active = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((thumb, index) => index === active ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      count.textContent = `${active + 1} / ${slides.length}`;
    };
    const move = (index) => {
      const bounded = Math.min(slides.length - 1, Math.max(0, index));
      track.scrollTo({left: bounded * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth'});
      const thumb = thumbs[bounded];
      if (thumb) thumb.parentElement.scrollTo({left: Math.max(0, thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2), behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    const openZoom = (index, source) => {
      if (!dialog.showModal) return false;
      const original = slides[index].querySelector('img');
      const img = document.createElement('img');
      img.src = slides[index].href;
      img.alt = original.alt;
      img.width = original.naturalWidth || original.width;
      img.height = original.naturalHeight || original.height;
      enlarged.replaceChildren(img);
      returnFocus = source;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return true;
    };
    previous.hidden = next.hidden = enlarge.hidden = false;
    previous.addEventListener('click', () => move(active - 1));
    next.addEventListener('click', () => move(active + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {event.preventDefault();move(index)}));
    slides.forEach((slide, index) => slide.addEventListener('click', event => {if (openZoom(index, slide)) event.preventDefault()}));
    enlarge.addEventListener('click', () => openZoom(active, enlarge));
    root.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close()});
    dialog.addEventListener('close', () => {document.documentElement.style.overflow = '';returnFocus?.focus({preventScroll:true})});
    let frame;
    track.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(refresh)}, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const resize = new ResizeObserver(() => {galleryWidth=track.clientWidth;track.scrollTo({left:active*galleryWidth,behavior:'instant'});refresh()});
    resize.observe(track);
    refresh();
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.hidden=false;
      button.addEventListener('click', () => {
        if (button.dataset.quantityChange === '1') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
    const variantSelect=root.querySelector('[data-variant-select]');
    variantSelect?.addEventListener('change', () => {
      const option=variantSelect.selectedOptions[0];
      const submit=root.querySelector('.product-form__submit');
      const available=option.dataset.available==='true';
      root.querySelectorAll('[data-product-price]').forEach(element=>element.textContent=option.dataset.price);
      submit.disabled=!available;
      submit.querySelector('[data-submit-label]').textContent=available?submit.dataset.preorderLabel:submit.dataset.soldOutLabel;
      root.querySelector('.wp-preorder-label').textContent=available?submit.dataset.preorderLabel:submit.dataset.soldOutLabel;
      const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
    });
    const pairForm = root.querySelector('[data-pair-form]');
    pairForm?.addEventListener('submit', async event => {
      event.preventDefault();
      const button = pairForm.querySelector('button');
      if (button.disabled) return;
      const label = button.querySelector('[data-pair-label]');
      const error = pairForm.querySelector('[data-pair-error]');
      const originalLabel = label.textContent;
      const data = new FormData(pairForm);
      const items = [0, 1].map(index => ({id: Number(data.get(`items[${index}][id]`)), quantity: 1}));
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = pairForm.dataset.loadingLabel;
      error.hidden = true;
      try {
        const response = await fetch(`${pairForm.action}.js`, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || pairForm.dataset.errorLabel);
        window.location.assign(pairForm.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || pairForm.dataset.errorLabel;
        error.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
      }
    });
    const sticky=root.querySelector('[data-sticky]');
    const buy=root.querySelector('[data-buy-area]');
    const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].boundingClientRect.bottom>=0||entries[0].isIntersecting},{threshold:0});
    observer.observe(buy);
    sticky.querySelector('a').addEventListener('click',()=>{sticky.hidden=true});
    root.addEventListener('shopify:section:unload',()=>{observer.disconnect();resize.disconnect()},{once:true});
  };
  const setup=(scope=document)=>scope.querySelectorAll('[data-waxy-product]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
